// assets/card-buy.js
// Horizon-compatible AJAX add-to-cart for your .sd-card-buy forms + toast notification

import { fetchConfig } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

function cleanVariantTitle(t) {
  if (!t) return '';
  const s = String(t).trim();
  if (!s) return '';
  const low = s.toLowerCase();
  if (low === 'default title' || low === 'default' || low === 'standard') return '';
  return s;
}

function getVariantId(form) {
  const checked = form.querySelector('input[name="id"][type="radio"]:checked');
  if (checked) return checked.value;

  const hidden = form.querySelector('input[name="id"][type="hidden"]');
  return hidden?.value;
}

function getQty(form) {
  const v = form.querySelector('input[name="quantity"]')?.value || '1';
  const n = parseInt(v, 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

function getVariantTitle(form) {
  const checked = form.querySelector('input[name="id"][type="radio"]:checked');
  if (checked) {
    const pill = checked.closest('.sd-pill');
    const t = pill?.querySelector('.sd-pill__title')?.textContent;
    return cleanVariantTitle(t);
  }
  const single = form.querySelector('.sd-pill__title')?.textContent;
  return cleanVariantTitle(single);
}

/* ---------- TOAST ---------- */
function ensureToast() {
  let el = document.getElementById('sd-toast');
  if (el) return el;

  el = document.createElement('div');
  el.id = 'sd-toast';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');

  document.body.appendChild(el);

  // Hard inline styles so theme CSS can’t override it
  el.style.position = 'fixed';
  el.style.left = '50%';
  el.style.top = '16px';                 // top is safer than bottom (drawers cover bottom)
  el.style.transform = 'translateX(-50%) translateY(-6px)';
  el.style.zIndex = '2147483647';        // max-ish
  el.style.padding = '12px 14px';
  el.style.borderRadius = '12px';
  el.style.fontWeight = '900';
  el.style.fontSize = '14px';
  el.style.lineHeight = '1.2';
  el.style.boxShadow = '0 12px 40px rgba(0,0,0,.35)';
  el.style.background = 'rgba(0,0,0,.92)';
  el.style.color = '#fff';
  el.style.maxWidth = '92vw';
  el.style.textAlign = 'center';
  el.style.pointerEvents = 'none';
  el.style.opacity = '0';
  el.style.transition = 'opacity .18s ease, transform .18s ease';

  return el;
}

let toastTimer = null;
function showToast(msg) {
  const el = ensureToast();
  el.textContent = msg;

  el.style.opacity = '1';
  el.style.transform = 'translateX(-50%) translateY(0px)';

  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    el.style.opacity = '0';
    el.style.transform = 'translateX(-50%) translateY(-6px)';
  }, 3500);
}

/* ---------- MAIN: intercept submit (capture) ---------- */
document.addEventListener(
  'submit',
  (e) => {
    const form = e.target.closest('form.sd-card-buy');
    if (!form) return;

    // Stop Shopify redirect
    e.preventDefault();
    e.stopPropagation();

    const id = getVariantId(form);
    const quantity = getQty(form);
    if (!id) return;

    const btn = form.querySelector('button[type="submit"], .sd-add');
    if (btn) btn.disabled = true;

    const productTitle = (form.dataset.productTitle || '').trim();
    const variantTitle = getVariantTitle(form);

    const body = JSON.stringify({ id, quantity });

    fetch(Theme.routes?.cart_add_url || '/cart/add.js', fetchConfig('json', { body }))
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.text());
        return res.json();
      })
      .then(() => {
        // Ask Horizon to refresh cart UI (drawer/badge/sections)
        document.dispatchEvent(
          new CustomEvent(ThemeEvents.cartUpdate, { detail: { data: {} } })
        );

        const parts = [];
        if (productTitle) parts.push(productTitle);
        if (variantTitle) parts.push(variantTitle);
        parts.push(`${quantity} Added`);

        const msg = parts.join(' - ');
        showToast(msg);
        console.log('SD TOAST:', msg);
      })
      .catch((err) => {
        console.error(err);
        showToast('Could not add item');
      })
      .finally(() => {
        if (btn) btn.disabled = false;
      });
  },
  true // capture so we beat theme handlers
);
